import clsx from 'clsx';
import { normaliseerKpi, type KpiWeergave } from '../utils/kpiWaarde.js';

interface KPITileProps {
  label: string;
  /** Getal, tekst of een KpiWeergave (met reden bij "—"). */
  waarde: string | number | KpiWeergave | null | undefined;
  /** Periode of bron, bv. "deze maand" (13 px). */
  periode?: string;
  icon?: React.ReactNode;
  trend?: { value: number; label: string };
  /** Behouden voor bestaande aanroepen; v4 gebruikt geen gekleurde kaartrand meer. */
  accentKleur?: string;
  onClick?: () => void;
}

/**
 * KPI volgens Kordaro v4: label 13, waarde 28, periode/reden 13. Geen gekleurde of zwarte tegel;
 * enkel klikbaar (en dan als echte knop) wanneer er een drilldown is.
 */
export function KPITile({ label, waarde, periode, icon, trend, onClick }: KPITileProps) {
  const w = normaliseerKpi(waarde);
  const inhoud = (
    <>
      <div className="flex items-start justify-between gap-3">
        <p className="text-[13px] leading-5 text-gray-500">{label}</p>
        {icon && <span className="text-gray-500 flex-none" aria-hidden="true">{icon}</span>}
      </div>
      <p className="mt-1 text-[28px] leading-9 font-semibold text-gray-900 tabular-nums">{w.tekst}</p>
      {w.reden && <p className="text-[13px] leading-5 text-gray-500">{w.reden}</p>}
      {!w.reden && periode && <p className="text-[13px] leading-5 text-gray-500">{periode}</p>}
      {trend && Number.isFinite(trend.value) && (
        <p className={clsx('text-[13px] leading-5 mt-1', trend.value >= 0 ? 'text-status-green' : 'text-status-red')}>
          {trend.value >= 0 ? 'Stijging' : 'Daling'} {Math.abs(trend.value)}% {trend.label}
        </p>
      )}
    </>
  );
  const basis = 'block w-full text-left bg-card border border-card-border rounded-[12px] p-4 md:p-6';
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={clsx(basis, 'hover:border-gray-400 transition-colors')}>
        {inhoud}
      </button>
    );
  }
  return <div className={basis}>{inhoud}</div>;
}
